import { SelectOptionType } from "../models/GlobalModels";

export const Constants = {
  APP_NAME: "Kshema CCE",

  // IS_USER_LOGED_IN: 'isUserLogedIn',
  AUTHENTICATION_DATUM: "authenticationDatum",
  // USER_MOBILE_NUMBER: 'userMobileNumber',
};

export const DEFAULT_OPTION: SelectOptionType = {
  label: "Select",
  value: null,
};

export const SIDE_MENU_STATUS = {
  OPEN: 1,
  CLOSE: 2,
  OPPOSITE: 3,
};

export const LIST_VIEW_ITEM = {
  LIST_ITEMS: "list-items",
  VIEW_ITEM: "view-item",
};

export const STORAGE_KEY = {
  AUTH_DATA: "kshemagpt-app-auth",
  SSOT: "fa-sso-token",
};

export const API_RESPONSE_CODE = {
  FAIL: "1",
  SUCCESS: "0",
};

export const LOGIN_STATUS = {
  INITIATED: "initiated",
  AUTHENTICATED: "authenticated",
  NO_AUTHENTICATED: "no-authenticated",
};

export const ROLE = {
  USER: "user",
  ASSISTANT: "assistant",
};
export const URL_END_POINT = {
  OPT_SEND: "/common-util-service/v1/otp/send",
  GET_CODE_ID: "/keycloak-kshema/pkce/codes",
  VERIFY_OTP: "/keycloak-kshema/pkce/token/generate",
  AUTHENTICATE: "/authenticate",
};

export const API_STATUS = {
  OTP_VERIFIED: 1,
  OTP_NOT_VERIFIED: 0,
  OPERATION_SUCCESSFUL: "Operation Successful",
  OPERATION_FAILED: "Operation Failed",
  STATUS_SUCCESS: "SUCCESS",
  FAILED: 'FAILED',
};

export const STATUS_MESSAGE = {
  OPT_VERIFIED: "OTP verified successfully, please continue.",
  OPT_VERIFICATION_ERROR:
    "OTP verification error, please enter mobile number again.",
  LOGIN_REQUIRED:
    "System unauthorized login required, please enter mobile number.",
  NO_RESPONSE: "No response",
  ERROR_FETCHING: "Error fetching response.",
  ENTER_VALID_MOBILE: "Enter valid mobile number.",
  ENTER_OTP: "Enter OTP, sent on your mobile number.",
  SOMETHING_WRONG: "Something went wrong.",
  RETRY_THIS: "Re-try this step.",
};
